import React, { useState } from "react"
import { Button } from "reactstrap"
import ModalFormOS from "./ModalFormOS"
import BotaoAcao from "./BotaoAcao"

// Modal "Novo Tipo de Serviço" — era uma duplicata idêntica em ListaOS e CriarOS.
// Controlado: `valor`/`onChange` para o campo, `onSalvar` para confirmar,
// `tipos` para listar os existentes.
// `onEditarTipo(oid, novoNome)` e `onExcluirTipo(tipo)` (opcionais) habilitam
// a edição inline e a exclusão de cada tipo já cadastrado.
const TipoServicoModal = ({
  isOpen,
  toggle,
  valor,
  onChange,
  onSalvar,
  tipos,
  onEditarTipo,
  onExcluirTipo,
}) => {
  // Edição inline: qual tipo está em modo de edição e o nome sendo digitado.
  const [editandoId, setEditandoId] = useState(null)
  const [editNome, setEditNome] = useState("")
  // Busca para filtrar a lista de tipos já cadastrados.
  const [busca, setBusca] = useState("")

  const iniciarEdicao = tipo => {
    setEditandoId(tipo.OID_TIPO)
    setEditNome(tipo.NAME)
  }

  const cancelarEdicao = () => {
    setEditandoId(null)
    setEditNome("")
  }

  const confirmarEdicao = async tipo => {
    const nome = editNome.trim()
    if (!nome || nome === tipo.NAME) {
      cancelarEdicao()
      return
    }
    await onEditarTipo(tipo.OID_TIPO, nome)
    cancelarEdicao()
  }

  const podeEditar = Boolean(onEditarTipo)
  const podeExcluir = Boolean(onExcluirTipo)
  const podeGerenciar = podeEditar || podeExcluir

  const termo = busca.trim().toLowerCase()
  const tiposFiltrados = termo
    ? tipos.filter(t => t.NAME.toLowerCase().includes(termo))
    : tipos

  return (
    <ModalFormOS
      isOpen={isOpen}
      toggle={toggle}
      title="Novo Tipo de Serviço"
      footer={
        <>
          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button color="primary" onClick={onSalvar}>
            <i className="bx bx-plus-circle me-1"></i>
            Criar
          </Button>
        </>
      }
    >
      <div className="mb-3">
        <label className="form-label">
          Nome do Tipo de Serviço <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          placeholder="Ex: Manutenção Preventiva"
          value={valor}
          onChange={e => onChange(e.target.value)}
          onKeyPress={e => {
            if (e.key === "Enter") {
              onSalvar()
            }
          }}
          autoFocus
        />
        <small className="text-muted">
          <i className="bx bx-info-circle me-1"></i>
          Digite o nome do novo tipo de serviço e pressione Enter ou clique em
          Criar
        </small>
      </div>

      {tipos.length > 0 && (
        <>
          <hr />
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <label className="text-muted small mb-0">
                Tipos de Serviço Disponíveis:
              </label>
              <span className="badge bg-light text-muted">
                {tiposFiltrados.length} de {tipos.length}
              </span>
            </div>

            {/* Barra de busca */}
            <div className="position-relative mb-2">
              <i
                className="bx bx-search position-absolute text-muted"
                style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}
              ></i>
              <input
                type="text"
                className="form-control form-control-sm ps-4"
                placeholder="Buscar tipo de serviço..."
                value={busca}
                onChange={e => setBusca(e.target.value)}
              />
            </div>

            <div style={{ maxHeight: "240px", overflowY: "auto" }}>
              {tiposFiltrados.length === 0 ? (
                <div className="text-center text-muted small py-3">
                  <i className="bx bx-search-alt me-1"></i>
                  Nenhum tipo encontrado para &quot;{busca}&quot;
                </div>
              ) : (
                tiposFiltrados.map(tipo =>
                  editandoId === tipo.OID_TIPO ? (
                    <div
                      key={tipo.OID_TIPO}
                      className="d-flex align-items-center gap-2 border rounded px-2 py-1 mb-2"
                    >
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        value={editNome}
                        onChange={e => setEditNome(e.target.value)}
                        onKeyPress={e => {
                          if (e.key === "Enter") confirmarEdicao(tipo)
                          if (e.key === "Escape") cancelarEdicao()
                        }}
                        autoFocus
                      />
                      <div className="d-flex gap-1">
                        <BotaoAcao
                          iconClassName="bx bx-check align-middle text-success"
                          onClick={() => confirmarEdicao(tipo)}
                          title="Salvar alteração"
                        />
                        <BotaoAcao
                          iconClassName="bx bx-x align-middle"
                          onClick={cancelarEdicao}
                          title="Cancelar"
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      key={tipo.OID_TIPO}
                      className="d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-2"
                    >
                      <span className="d-flex align-items-center">
                        <i className="bx bx-check-circle text-primary me-1"></i>
                        {tipo.NAME}
                      </span>
                      {podeGerenciar && (
                        <div className="d-flex gap-1">
                          {podeEditar && (
                            <BotaoAcao
                              iconClassName="bx bx-edit align-middle"
                              onClick={() => iniciarEdicao(tipo)}
                              title="Editar tipo de serviço"
                            />
                          )}
                          {podeExcluir && (
                            <BotaoAcao
                              iconClassName="bx bx-trash align-middle text-danger"
                              onClick={() => onExcluirTipo(tipo)}
                              title="Excluir tipo de serviço"
                            />
                          )}
                        </div>
                      )}
                    </div>
                  ),
                )
              )}
            </div>
          </div>
        </>
      )}
    </ModalFormOS>
  )
}

export default TipoServicoModal
